// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Xf-z","heading":"Yf-z","brandPromo":"Zf-z"};